// Simple plan name formatter for UI display

export function formatPlanName(plan: string | null | undefined): string {
  if (!plan) return 'Free Edition';
  
  // Capitalize first letter and add "Edition"
  const formatted = plan.charAt(0).toUpperCase() + plan.slice(1).toLowerCase();
  return `${formatted} Edition`;
}

// For places where you just want the plan name without "Edition"
export function formatPlanShortName(plan: string | null | undefined): string {
  if (!plan) return 'Free';
  
  // Capitalize first letter
  return plan.charAt(0).toUpperCase() + plan.slice(1).toLowerCase();
}